export default "__VITE_ASSET__38e4be3d__"